import React from "react";

export default function PrivateAccess({ children }) {
  // Access code removed for public launch
  // Site is now publicly accessible
  return children;
}
